import { render } from "./partnerList.vue?vue&type=template&id=378bde70&scoped=true"
import script from "./partnerList.vue?vue&type=script&lang=js"
export * from "./partnerList.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&lang=css"
import "./partnerList.vue?vue&type=style&index=1&id=378bde70&scoped=true&lang=css"
import "./partnerList.vue?vue&type=style&index=2&id=378bde70&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378bde70"]])

export default __exports__